var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevronUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "#303030",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.7387 10.811C11.4249 11.0813 10.9514 11.0461 10.681 10.7322L8.00335 7.63264L5.31782 10.7387C5.04691 11.0521 4.57328 11.0865 4.25995 10.8156C3.94661 10.5447 3.91222 10.071 4.18313 9.75769L7.05814 6.43245C7.55727 5.85515 8.45268 5.85597 8.95076 6.43417L11.8175 9.75324C12.0878 10.0671 12.0526 10.5406 11.7387 10.811Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronUp);
export default __webpack_public_path__ + "static/media/chevron-up.dff4e351.svg";
export { ForwardRef as ReactComponent };